// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GKoM","col":"styles_col__3175d"};